import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  TextField,
} from '@material-ui/core';

import styles from './styles';

export const getDefaultStateForProps = (description) => ({
  description,
  isValid: true,
  message: 'Please provide a valid description (between 0 and 1024 characters in length).',
});

export class EditEventDescriptionComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = getDefaultStateForProps(props.description);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.description && prevProps.description !== this.props.description) {
      this.setState(getDefaultStateForProps(this.props.description));
    }
  }

  handleDescriptionChange = (e) => {
    const changedValue = e.target.value;
    const isValid
      = changedValue !== null
        && changedValue !== undefined
        && changedValue.length <= 1024;
    this.setState((prevState) => ({
      description: changedValue,
      isValid,
      message: prevState.message,
    }));
    this.props.onUpdate(changedValue, isValid);
  }

  render() {
    const { classes } = this.props;
    const {
      description,
      isValid,
      message,
    } = this.state;

    return (
      <TextField
        fullWidth
        error={!isValid}
        className={classes.container}
        multiline
        rows="2"
        rowsMax="4"
        variant="outlined"
        id="Description"
        label="Description"
        value={description}
        onChange={this.handleDescriptionChange}
        helperText={!isValid && message}
      />
    );
  }
}

EditEventDescriptionComponent.propTypes = {
  classes: PropTypes.object,
  onUpdate: PropTypes.func,
  description: PropTypes.string,
};

EditEventDescriptionComponent.defaultProps = {
  classes: {},
  onUpdate: () => {},
  description: '',
};

export default (withStyles(styles, { withTheme: true })(EditEventDescriptionComponent));
